(function () {
  'use strict';

  var root = document.querySelector('[data-fh-showroom]');
  if (!root) return;

  document.documentElement.classList.add('fh-showroom-page');

  var DEFAULT_MAKE = 'Dodge';
  var LAST_VEHICLE_KEY = 'fh-sr-last-vehicle';
  var OTHER_CATEGORY = 'Other';
  var HIDDEN_PART_TYPES = {
    tools: true,
    tool: true,
    'wheel spacers': true,
    'wheel spacer': true,
    aerodynamics: true,
    aerodynamic: true,
    'carbon fiber': true,
    'carbon fiber parts': true,
    other: true
  };
  var CATEGORY_IMAGES = {
    brake: 'https://fasthemis.com/cdn/shop/files/0000645_5617_HB377Z.760_fe479682-6330-410c-9266-2fa1d6495deb.webp?v=1771902813&width=800',
    'carbon fiber': 'https://fasthemis.com/cdn/shop/files/0849_F143839212_19243750-7c8f-4711-9696-f161e2f6e76f.webp?v=1766371722&width=800',
    cooling: 'https://fasthemis.com/cdn/shop/files/0000089_5490_F143836082_74d38605-fed2-495e-8c4d-bba56f267b3e.webp?v=1771672450&width=800',
    engine: 'https://fasthemis.com/cdn/shop/files/0003183-800_762cca9a-ced5-4d62-9234-3744df8ba05e.webp?v=1771672632&width=800',
    exterior: 'https://fasthemis.com/cdn/shop/files/0000931_8417_ac-hd15dgchhc-oe_01_3_ba7cac47-cb3c-48ae-a8f7-f07df452e4ff.webp?v=1771672516&width=1000',
    interior: 'https://fasthemis.com/cdn/shop/files/0002043_4216_12226_145f2cd5-e7b3-4e3b-a3e0-0982a97731ec.webp?v=1771902886&width=800',
    lighting: 'https://fasthemis.com/cdn/shop/files/6302_F143836734_d2b1d3fb-62d7-4a05-ac15-ba78e79802c8.webp?v=1766378298&width=800',
    supercharger: 'https://fasthemis.com/cdn/shop/files/0001292_0031_hemi-supercharger-black_37081769-55ba-483f-b5c6-ee663420fd74.webp?v=1771667044&width=800',
    suspension: 'https://fasthemis.com/cdn/shop/files/0002314_bc-racing-default-br-series_5dcce89d-3f36-4be0-a82a-fa93363369cd.webp?v=1771667067&width=800',
    transmission: 'https://fasthemis.com/cdn/shop/files/3024_F143844309_9a510566-8572-4495-9ccb-30f0b3ea7baf.webp?v=1766372746&width=800',
    wheels: 'https://fasthemis.com/cdn/shop/files/0000121_51817082643_beda775105_k_06da59a4-5acb-45c7-9eb6-fe5b6a6e294b.webp?v=1771738303&width=800',
    exhaust: 'https://fasthemis.com/cdn/shop/files/0000008_ram_srt10.png?v=1782956873&width=800',
    'camshaft kits': 'https://fasthemis.com/cdn/shop/files/0027_Untitleddesign_63_4082aa12-8263-4365-9476-bc4ae1ff186b.webp?v=1766650250&width=800',
    'air intakes': 'https://fasthemis.com/cdn/shop/files/8507_54-12162-c_1_2_190f8a20-e0e3-42c4-af1e-e383b8b7f7d0.webp?v=1766378329&width=800',
    'performance bundles': 'https://cdn.shopify.com/s/files/1/0660/8542/1268/files/85_HP_2.png?v=1786775903',
    'suspension kits': 'https://fasthemis.com/cdn/shop/files/FOX883-06-080.1_20FOX883-26-029.1_1100x_e2283202-4a04-498b-b876-e284dbcb82c6.jpg?v=1784522993&width=800'
  };
  var CATEGORY_SORT = [
    'air intakes', 'exhaust', 'camshaft kits',
    'brake', 'engine', 'supercharger', 'exterior',
    'suspension', 'suspension kits', 'performance bundles',
    'cooling', 'interior', 'lighting', 'transmission', 'wheels'
  ];
  var PROMOTED_SUBTYPES = [
    { value: 'Master Camshaft Kit', imageKey: 'camshaft kits' },
    { value: 'Exhaust Systems', imageKey: 'exhaust' },
    { value: 'Air Intakes', imageKey: 'air intakes' },
    { value: 'Suspension Kits', imageKey: 'suspension kits' },
    { value: 'One Click Power Kits', imageKey: 'performance bundles' }
  ];
  var GRID_PAGE_SIZE = 60;
  var GRID_LOAD_MORE = 20;
  var SEARCH_TYPE_PILL_MAX = 10;
  var SEARCH_STOP = {
    a: 1, an: 1, and: 1, at: 1, by: 1, for: 1, from: 1, in: 1, into: 1,
    is: 1, it: 1, my: 1, of: 1, on: 1, or: 1, our: 1, part: 1, parts: 1,
    product: 1, products: 1, the: 1, this: 1, that: 1, to: 1, with: 1, your: 1,
    kit: 1, kits: 1
  };
  var SEARCH_SYNONYMS = {
    pad: ['pads', 'brake pads'],
    pads: ['brake pads'],
    rotor: ['rotors', 'brake rotors'],
    rotors: ['rotor', 'brake rotors'],
    caliper: ['calipers'],
    calipers: ['caliper'],
    header: ['headers'],
    headers: ['header'],
    intake: ['intakes'],
    intakes: ['intake']
  };
  var SEARCH_POSITION = {
    front: 1, rear: 1, rears: 1
  };
  var WEAK_ENGINE_KEYS = {
    v6: 1, v8: 1, v10: 1, i4: 1, i6: 1, l: 1, ev: 1
  };

  var ymmIndex = {};
  var ymmRowsAll = [];
  var ymmInfoByModelKey = {};
  var ymmMakesByModel = {};
  var ymmSearch = { makes: [], models: [], engines: [] };
  var products = [];
  var catalogReady = false;
  var catalogError = false;
  var lightboxLastFocus = null;
  var searchPool = [];
  var searchPoolKey = '';
  var searchRaf = 0;

  var config = {
    collectionHandle: 'data-motorstate-products',
    collectionId: 458934255828,
    collectionSource: 'fallback',
    pageSize: 250,
    productsCount: 0
  };
  try {
    var configEl = document.getElementById('fh-sr-config');
    if (configEl) config = Object.assign(config, JSON.parse(configEl.textContent || '{}'));
  } catch (err) {
    /* keep defaults */
  }

  try {
    var ymmMapEl = document.getElementById('fh-sr-ymm-map-data');
    var ymmMap = ymmMapEl ? JSON.parse(ymmMapEl.textContent || '[]') : [];
    ymmRowsAll = Array.isArray(ymmMap) ? ymmMap : [];
  } catch (err) {
    ymmRowsAll = [];
  }

  var state = {
    screen: 'ymm',
    vehicle: null,
    allProducts: false,
    queryVehicle: null,
    category: null,
    mode: 'category',
    query: '',
    vendor: '',
    subType: '',
    engine: '',
    visibleCount: GRID_PAGE_SIZE,
    lightboxProductId: null,
    lightboxTab: 'details'
  };

  var yearEl = root.querySelector('[data-sr-year]');
  var makeEl = root.querySelector('[data-sr-make]');
  var modelEl = root.querySelector('[data-sr-model]');
  var engineEl = root.querySelector('[data-sr-engine]');
  var formEl = root.querySelector('[data-sr-ymm-form]');
  var noticeEl = root.querySelector('[data-sr-notice]');
  var continueEl = root.querySelector('[data-sr-continue]');
  var searchAllEl = root.querySelector('[data-sr-search-all]');
  var loadEl = root.querySelector('[data-sr-load]');
  var backEl = root.querySelector('[data-sr-back]');
  var backLabelEl = root.querySelector('[data-sr-back-label]');
  var cartEl = root.querySelector('[data-sr-cart]');
  var cartCountEl = root.querySelector('[data-sr-cart-count]');
  var catsEl = root.querySelector('[data-sr-cats]');
  var catsEmptyEl = root.querySelector('[data-sr-cats-empty]');
  var vehicleEls = root.querySelectorAll('[data-sr-vehicle], [data-sr-vehicle-rail]');
  var railTitleEl = root.querySelector('[data-sr-rail-title]');
  var countEl = root.querySelector('[data-sr-count]');
  var browseEl = root.querySelector('[data-sr-browse]');
  var railFiltersEl = root.querySelector('[data-sr-rail-filters]');
  var railSearchEl = root.querySelector('[data-sr-rail-search]');
  var searchFormEl = root.querySelector('[data-sr-search-form]');
  var searchEl = root.querySelector('[data-sr-search]');
  var vendorEl = root.querySelector('[data-sr-vendor]');
  var typesEl = root.querySelector('[data-sr-types]');
  var typeSelectEl = root.querySelector('[data-sr-type-select]');
  var typeFilterEl = root.querySelector('[data-sr-type-filter]');
  var engineFilterEl = root.querySelector('[data-sr-engine-filter]');
  var enginesEl = root.querySelector('[data-sr-engines]');
  var engineSelectEl = root.querySelector('[data-sr-engine-select]');
  var gridEl = root.querySelector('[data-sr-grid]');
  var moreEl = root.querySelector('[data-sr-more]');
  var loadMoreEl = root.querySelector('[data-sr-load-more]');
  var emptyEl = root.querySelector('[data-sr-empty]');
  var searchIdleEl = root.querySelector('[data-sr-search-idle]');
  var searchIdleTilesEl = root.querySelector('[data-sr-search-idle-tiles]');
  var searchIdleKey = '';
  var lightboxEl = root.querySelector('[data-sr-lightbox]');
  var lightboxImageEl = root.querySelector('[data-sr-lightbox-image]');
  var lightboxThumbsEl = root.querySelector('[data-sr-lightbox-thumbs]');
  var lightboxVendorEl = root.querySelector('[data-sr-lightbox-vendor]');
  var lightboxTitleEl = document.getElementById('fh-sr-lightbox-title');
  var lightboxPriceEl = root.querySelector('[data-sr-lightbox-price]');
  var lightboxReviewsEl = root.querySelector('[data-sr-lightbox-reviews]');
  var lightboxScrollEl = root.querySelector('[data-sr-lightbox-scroll]');
  var lightboxDescEl = root.querySelector('[data-sr-lightbox-desc]');
  var lightboxFitmentEl = root.querySelector('[data-sr-lightbox-fitment]');
  var lightboxTabsEl = root.querySelector('[data-sr-lightbox-tabs]');
  var lightboxVariantEl = root.querySelector('[data-sr-lightbox-variant]');
  var lightboxVariantWrap = root.querySelector('[data-sr-lightbox-variant-wrap]');
  var lightboxAtcEl = root.querySelector('[data-sr-atc]');
  var STAR_SVG = '<svg viewBox="0 0 20 20" aria-hidden="true"><path fill="currentColor" d="M10 1.6 12.7 7l6 .9-4.4 4.2 1 5.9L10 15.2 4.7 18l1-5.9L1.3 7.9 7.3 7 10 1.6Z"/></svg>';

  function absUrl(value) {
    var url = String(value || '').trim();
    if (!url) return '';
    if (url.indexOf('//') === 0) return 'https:' + url;
    return url;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function isPhone() {
    return window.matchMedia && window.matchMedia('(max-width: 820px)').matches;
  }

  function uniqueSorted(values) {
    var seen = {};
    var out = [];
    (values || []).forEach(function (value) {
      var key = String(value || '').trim();
      if (!key || seen[key]) return;
      seen[key] = true;
      out.push(key);
    });
    return out.sort(function (a, b) {
      return a.localeCompare(b);
    });
  }

  function listItemText(item) {
    if (item == null) return '';
    if (typeof item === 'string' || typeof item === 'number') return String(item).trim();
    if (typeof item === 'object') {
      if (item.value != null && item.value !== item) return listItemText(item.value);
      if (item.name != null && item.name !== item) return listItemText(item.name);
    }
    var text = String(item).trim();
    return text === '[object Object]' ? '' : text;
  }

  function asStringList(value) {
    if (!value) return [];
    if (Array.isArray(value)) {
      return value.map(listItemText).filter(Boolean);
    }
    return [listItemText(value)].filter(Boolean);
  }

  function productTypeList(product) {
    if (product && product._typeList) return product._typeList;
    var seen = {};
    var list = [];
    function add(value) {
      var text = String(value || '').trim();
      if (!text) return;
      var key = text.toLowerCase();
      if (seen[key]) return;
      seen[key] = true;
      list.push(text);
    }
    asStringList(product && product.partTypes).forEach(add);
    asStringList(product && product.subTypes).forEach(add);
    if (product) product._typeList = list;
    return list;
  }

  function productPartTypes(product) {
    var cleaned = asStringList(product && product.partTypes);
    return cleaned.length ? cleaned : [OTHER_CATEGORY];
  }

  function productSubTypes(product) {
    return asStringList(product && product.subTypes);
  }

  function normalizeCatKey(name) {
    return String(name || '')
      .toLowerCase()
      .replace(/&/g, ' ')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function partTypeImageKey(name) {
    return normalizeCatKey(name).replace(/\s+parts$/, '').replace(/\s+kit$/, '');
  }

  function isHiddenPartType(name) {
    return !!(HIDDEN_PART_TYPES[normalizeCatKey(name)] || HIDDEN_PART_TYPES[partTypeImageKey(name)]);
  }

  function promotedSubtype(name) {
    var target = String(name || '');
    for (var i = 0; i < PROMOTED_SUBTYPES.length; i++) {
      if (PROMOTED_SUBTYPES[i].value === target) return PROMOTED_SUBTYPES[i];
    }
    return null;
  }

  function categoryImageForKey(key) {
    if (CATEGORY_IMAGES[key]) return CATEGORY_IMAGES[key];
    var best = '';
    var bestLen = 0;
    Object.keys(CATEGORY_IMAGES).forEach(function (csvKey) {
      if (key === csvKey || key.indexOf(csvKey) === 0 || csvKey.indexOf(key) === 0) {
        if (csvKey.length > bestLen) {
          bestLen = csvKey.length;
          best = CATEGORY_IMAGES[csvKey];
        }
      }
    });
    return best;
  }

  function categorySortIndex(key) {
    var exact = CATEGORY_SORT.indexOf(key);
    if (exact !== -1) return exact;
    var best = -1;
    var bestLen = 0;
    for (var i = 0; i < CATEGORY_SORT.length; i++) {
      var sortKey = CATEGORY_SORT[i];
      if (key === sortKey || key.indexOf(sortKey) === 0 || sortKey.indexOf(key) === 0) {
        if (sortKey.length > bestLen) {
          bestLen = sortKey.length;
          best = i;
        }
      }
    }
    return best === -1 ? 1000 : best;
  }

  function productHasFitment(product) {
    return asStringList(product && product.ranges).length +
      asStringList(product && product.years).length +
      asStringList(product && product.models).length > 0;
  }

  function isAvailable(product) {
    return product && product.available === true;
  }

  function matcherVehicle() {
    var vehicle = state.vehicle;
    if (!vehicle) return null;
    if (vehicle.engine) return vehicle;
    return {
      year: vehicle.year,
      model: vehicle.model,
      engine: 'All',
      submodel: 'All',
      modelKey: vehicle.model
    };
  }

  function vehicleEngines() {
    var vehicle = state.vehicle;
    if (!vehicle || vehicle.engine) return [];
    var map = ymmIndex[vehicle.year] &&
      ymmIndex[vehicle.year][vehicle.make] &&
      ymmIndex[vehicle.year][vehicle.make][vehicle.model];
    return map ? Object.keys(map).sort(function (a, b) { return a.localeCompare(b); }) : [];
  }

  function vehicleForEngine(engine) {
    var vehicle = state.vehicle;
    if (!vehicle || !engine) return null;
    var row = ymmIndex[vehicle.year] &&
      ymmIndex[vehicle.year][vehicle.make] &&
      ymmIndex[vehicle.year][vehicle.make][vehicle.model] &&
      ymmIndex[vehicle.year][vehicle.make][vehicle.model][engine];
    if (row) return vehicleFromRow(row);
    return {
      year: vehicle.year,
      model: vehicle.model,
      engine: engine,
      submodel: engine,
      modelKey: (vehicle.model + ' ' + engine).trim()
    };
  }

  function productMatchesEngine(product, engine) {
    if (!engine) return true;
    if (!productHasFitment(product)) return true;
    if (typeof window.kitMatchesFitment !== 'function') return false;
    var vehicle = vehicleForEngine(engine);
    return !!(vehicle && window.kitMatchesFitment(product, vehicle));
  }

  function showEngineFilter() {
    return state.mode === 'category' && !!(state.vehicle && !state.vehicle.engine && vehicleEngines().length);
  }

  function matchesVehicle(product) {
    if (state.allProducts) return true;
    if (!state.vehicle) return false;
    if (!productHasFitment(product)) return true;
    if (typeof window.kitMatchesFitment !== 'function') return false;
    return window.kitMatchesFitment(product, matcherVehicle());
  }

  function vehicleProducts() {
    return products.filter(function (product) {
      return isAvailable(product) && matchesVehicle(product);
    });
  }

  function categoryProducts() {
    var promoted = promotedSubtype(state.category);
    return vehicleProducts().filter(function (product) {
      if (promoted) return productSubTypes(product).indexOf(promoted.value) !== -1;
      return productPartTypes(product).indexOf(state.category) !== -1;
    });
  }

  function productSkuList(product) {
    if (product._skus) return product._skus;
    var seen = {};
    var list = [];
    function add(value) {
      var sku = String(value || '').trim().toLowerCase();
      if (!sku || seen[sku]) return;
      seen[sku] = true;
      list.push(sku);
    }
    add(product.sku);
    (product.variants || []).forEach(function (variant) {
      if (!variant) return;
      add(variant.sku);
      add(variant.barcode);
    });
    product._skus = list;
    return list;
  }

  function parseFitmentRangeEntry(entry) {
    var raw = String(entry || '').trim();
    var sep = raw.lastIndexOf('|');
    if (sep < 1) return null;
    var modelKey = raw.slice(0, sep).trim();
    var span = raw.slice(sep + 1).trim();
    var m = span.match(/^(\d{4})\s*-\s*(\d{4})$/);
    if (!modelKey || !m) return null;
    var start = parseInt(m[1], 10);
    var end = parseInt(m[2], 10);
    if (!start || !end || end < start || end - start > 40) return null;
    return { modelKey: modelKey, start: start, end: end };
  }

  function eachTitleYearSpan(title, fn) {
    var re = /(\d{4})\s*-\s*(\d{4})/g;
    var text = String(title || '');
    var match;
    while ((match = re.exec(text))) {
      var start = parseInt(match[1], 10);
      var end = parseInt(match[2], 10);
      if (start && end && end >= start && end - start <= 40) fn(start, end);
    }
  }

  function productFitmentYears(product) {
    if (product._fitYears) return product._fitYears;
    var years = {};
    function addYear(year) {
      var n = parseInt(year, 10);
      if (n >= 1900 && n <= 2100) years[n] = true;
    }
    asStringList(product && product.years).forEach(addYear);
    asStringList(product && product.ranges).forEach(function (entry) {
      var parsed = parseFitmentRangeEntry(entry);
      if (!parsed) return;
      var year;
      for (year = parsed.start; year <= parsed.end; year++) years[year] = true;
    });
    eachTitleYearSpan(product && product.title, function (start, end) {
      var year;
      for (year = start; year <= end; year++) years[year] = true;
    });
    product._fitYears = years;
    return years;
  }

  function productOverlapsYearSpan(product, start, end) {
    var years = productFitmentYears(product);
    var year;
    for (year = start; year <= end; year++) {
      if (years[year]) return true;
    }
    return false;
  }

  function productFitmentSearchParts(product) {
    var parts = [];
    var seen = {};
    function add(value) {
      var text = String(value || '').trim();
      if (!text) return;
      var key = text.toLowerCase();
      if (seen[key]) return;
      seen[key] = true;
      parts.push(text);
    }
    function addModelKey(modelKey) {
      add(modelKey);
      var info = ymmInfoByModelKey[String(modelKey || '').toLowerCase()];
      if (info) {
        add(info.model);
        add(info.engine);
        Object.keys(info.makes).forEach(add);
        return;
      }
      var firstSpace = String(modelKey || '').indexOf(' ');
      if (firstSpace > 0) {
        var maybeModel = modelKey.slice(0, firstSpace);
        var makes = ymmMakesByModel[maybeModel.toLowerCase()];
        if (makes) {
          add(maybeModel);
          Object.keys(makes).forEach(add);
        }
      }
    }
    asStringList(product && product.models).forEach(addModelKey);
    asStringList(product && product.ranges).forEach(function (entry) {
      var parsed = parseFitmentRangeEntry(entry);
      if (!parsed) {
        add(entry);
        return;
      }
      addModelKey(parsed.modelKey);
      add(parsed.start + '-' + parsed.end);
    });
    asStringList(product && product.years).forEach(add);
    Object.keys(productFitmentYears(product)).forEach(add);
    return parts;
  }

  function productTypeSearchParts(product) {
    var parts = [];
    var seen = {};
    function add(value) {
      var text = String(value || '').trim();
      if (!text) return;
      var key = text.toLowerCase();
      if (seen[key]) return;
      seen[key] = true;
      parts.push(text);
      if (text.indexOf('-') === -1) return;
      var open = text.replace(/-/g, '');
      var openKey = open.toLowerCase();
      if (open && !seen[openKey]) {
        seen[openKey] = true;
        parts.push(open);
      }
      var spaced = text.replace(/-/g, ' ');
      var spacedKey = spaced.toLowerCase();
      if (spaced && !seen[spacedKey]) {
        seen[spacedKey] = true;
        parts.push(spaced);
      }
    }
    productTypeList(product).forEach(add);
    return parts;
  }

  function productSearchText(product) {
    if (product._q) return product._q;
    var parts = [product.title, product.vendor, product.type, product.handle]
      .concat(productTypeSearchParts(product))
      .concat(productSkuList(product))
      .concat(productFitmentSearchParts(product));
    product._q = parts.join(' ').toLowerCase();
    return product._q;
  }

  function vehicleKey() {
    if (state.allProducts) return '__all__';
    if (!state.vehicle) return '';
    return state.vehicle.ymm || [
      state.vehicle.year,
      state.vehicle.make,
      state.vehicle.model,
      state.vehicle.engine
    ].join('|');
  }

  function vehicleLabel() {
    if (state.allProducts) {
      return state.queryVehicle && state.queryVehicle.label ? state.queryVehicle.label : 'All products';
    }
    return state.vehicle && state.vehicle.label ? state.vehicle.label : '';
  }

  function ensureSearchPool() {
    var key = vehicleKey();
    if (searchPoolKey === key && searchPool.length) return searchPool;
    searchPool = vehicleProducts();
    var i;
    for (i = 0; i < searchPool.length; i++) {
      productSkuList(searchPool[i]);
      productTypeList(searchPool[i]);
      productSearchText(searchPool[i]);
    }
    searchPoolKey = key;
    return searchPool;
  }

  function rawSearchTokens(query) {
    return String(query || '')
      .toLowerCase()
      .replace(/[^\w.\-]+/g, ' ')
      .trim()
      .split(/\s+/)
      .filter(Boolean);
  }

  function compactAlnum(text) {
    return String(text || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  }

  function isDisplacementToken(token) {
    return /^\d+\.\d+l?$/.test(String(token || '').toLowerCase());
  }

  function displacementNeedle(token) {
    var match = String(token || '').toLowerCase().match(/^(\d+\.\d+)l?$/);
    return match ? match[1] : '';
  }

  function findTokenPhrase(tokens, used, phrase) {
    if (!phrase || !phrase.length) return -1;
    var i;
    var j;
    var ok;
    for (i = 0; i <= tokens.length - phrase.length; i++) {
      ok = true;
      for (j = 0; j < phrase.length; j++) {
        if (used[i + j] || tokens[i + j] !== phrase[j]) {
          ok = false;
          break;
        }
      }
      if (ok) return i;
    }
    return -1;
  }

  function markPhraseUsed(used, start, count) {
    var i;
    for (i = 0; i < count; i++) used[start + i] = true;
  }

  function modelNameAliases(make, model) {
    var names = [model];
    var makePrefix;
    if (!model) return names;
    if (make) {
      makePrefix = make.toLowerCase() + ' ';
      if (model.toLowerCase().indexOf(makePrefix) === 0) {
        names.push(model.slice(make.length).trim());
      }
    } else if (/^ram\s+/i.test(model)) {
      names.push(model.replace(/^ram\s+/i, '').trim());
    }
    return names.filter(Boolean);
  }

  function enginesForParsed(year, make, model) {
    var map = year && ymmIndex[year] ? ymmIndex[year] : null;
    var names = {};
    if (!map) {
      ymmSearch.engines.forEach(function (engine) { names[engine] = true; });
      return Object.keys(names);
    }
    function addFromModels(modelsMap) {
      Object.keys(modelsMap || {}).forEach(function (modelName) {
        if (model && modelName !== model) return;
        Object.keys(modelsMap[modelName] || {}).forEach(function (engine) {
          names[engine] = true;
        });
      });
    }
    if (make && map[make]) {
      addFromModels(map[make]);
    } else {
      Object.keys(map).forEach(function (makeName) {
        addFromModels(map[makeName]);
      });
    }
    return Object.keys(names);
  }

  function matchEngineName(candidates, tokenCompact) {
    if (!tokenCompact || tokenCompact.length < 2) return '';
    if (WEAK_ENGINE_KEYS[tokenCompact]) return '';
    var hits = (candidates || []).filter(function (engine) {
      var compact = compactAlnum(engine);
      return compact === tokenCompact || compact.indexOf(tokenCompact) !== -1;
    });
    return hits.length === 1 ? hits[0] : '';
  }

  function resolveParsedVehicle(year, make, model, engine, engineSoft) {
    if (!year || !model || !ymmIndex[year]) return null;
    var yearMap = ymmIndex[year];
    var modelNames = modelNameAliases(make, model);
    var resolvedMake = make;
    var resolvedModel = '';
    var makeName;
    var i;

    if (resolvedMake && !yearMap[resolvedMake]) resolvedMake = '';

    function hasModel(makeKey, modelName) {
      return !!(yearMap[makeKey] && yearMap[makeKey][modelName]);
    }

    for (i = 0; i < modelNames.length; i++) {
      if (resolvedMake && hasModel(resolvedMake, modelNames[i])) {
        resolvedModel = modelNames[i];
        break;
      }
    }

    if (!resolvedModel) {
      Object.keys(yearMap).forEach(function (key) {
        if (resolvedModel) return;
        for (i = 0; i < modelNames.length; i++) {
          if (hasModel(key, modelNames[i])) {
            if (resolvedMake && key !== resolvedMake) return;
            makeName = key;
            resolvedModel = modelNames[i];
            return;
          }
        }
      });
      if (!resolvedMake && makeName) resolvedMake = makeName;
    }

    if (!resolvedMake || !resolvedModel) return null;

    var enginesMap = yearMap[resolvedMake][resolvedModel];
    var resolved;
    if (engine && enginesMap[engine]) resolved = vehicleFromRow(enginesMap[engine]);
    if (!resolved && engine) {
      var matched = matchEngineName(Object.keys(enginesMap), compactAlnum(engine));
      if (matched && enginesMap[matched]) resolved = vehicleFromRow(enginesMap[matched]);
    }
    if (!resolved) {
      resolved = {
        ymm: [year, resolvedMake, resolvedModel].join('_'),
        year: year,
        make: resolvedMake,
        model: resolvedModel,
        engine: '',
        modelKey: resolvedModel,
        label: [year, resolvedMake, resolvedModel].join(' '),
        fitment: ''
      };
    }
    if (engineSoft) resolved.engineSoft = engineSoft;
    return resolved;
  }

  function parseQueryFitment(query) {
    var tokens = rawSearchTokens(query);
    var used = tokens.map(function () { return false; });
    var year = '';
    var make = '';
    var model = '';
    var engine = '';
    var engineSoft = '';
    var i;
    var idx;
    var entry;
    var candidates;
    var pair;
    var matched;

    for (i = 0; i < tokens.length; i++) {
      if (isSearchYearToken(tokens[i]) && ymmIndex[tokens[i]]) {
        if (!year) year = tokens[i];
        used[i] = true;
      }
    }

    for (i = 0; i < ymmSearch.models.length; i++) {
      entry = ymmSearch.models[i];
      idx = findTokenPhrase(tokens, used, entry.tokens);
      if (idx !== -1) {
        model = entry.name;
        markPhraseUsed(used, idx, entry.tokenCount);
        break;
      }
    }

    for (i = 0; i < ymmSearch.makes.length; i++) {
      entry = ymmSearch.makes[i];
      idx = findTokenPhrase(tokens, used, entry.tokens);
      if (idx !== -1) {
        make = entry.name;
        markPhraseUsed(used, idx, entry.tokenCount);
        break;
      }
    }

    candidates = enginesForParsed(year, make, model);
    for (i = 0; i < tokens.length; i++) {
      if (used[i]) continue;
      if (i + 1 < tokens.length && !used[i + 1]) {
        pair = compactAlnum(tokens[i] + tokens[i + 1]);
        matched = matchEngineName(candidates, pair);
        if (matched) {
          engine = matched;
          used[i] = true;
          used[i + 1] = true;
          break;
        }
      }
      matched = matchEngineName(candidates, compactAlnum(tokens[i]));
      if (matched) {
        engine = matched;
        used[i] = true;
        if (isDisplacementToken(tokens[i])) engineSoft = displacementNeedle(tokens[i]);
        break;
      }
    }

    var vehicle = resolveParsedVehicle(year, make, model, engine, engineSoft);
    var ignore = {};
    tokens.forEach(function (token, tokenIdx) {
      if (used[tokenIdx]) ignore[token] = true;
    });
    if (vehicle) {
      rawSearchTokens([
        vehicle.year,
        vehicle.make,
        vehicle.model,
        vehicle.engine,
        vehicle.label
      ].join(' ')).forEach(function (token) {
        ignore[token] = true;
      });
    }

    return {
      vehicle: vehicle,
      tokens: tokens.filter(function (token, tokenIdx) {
        return !used[tokenIdx] && !SEARCH_STOP[token] && !ignore[token];
      })
    };
  }

  function queryUsesParsedVehicle() {
    return !!(state.allProducts || !state.vehicle);
  }

  function querySearchPlan(query) {
    var raw = String(query || '').trim();
    var parsed = parseQueryFitment(raw);
    var useParsed = !!(parsed.vehicle && queryUsesParsedVehicle());
    return {
      raw: raw,
      vehicle: useParsed ? parsed.vehicle : null,
      tokens: useParsed ? parsed.tokens : searchTokens(raw)
    };
  }

  function matcherForParsedVehicle(vehicle) {
    if (!vehicle) return null;
    if (vehicle.engine) return vehicle;
    return {
      year: vehicle.year,
      model: vehicle.model,
      engine: 'All',
      submodel: 'All',
      modelKey: vehicle.model
    };
  }

  function productMatchesParsedVehicle(product, vehicle) {
    if (!vehicle) return true;
    if (!productHasFitment(product)) return true;
    if (typeof window.kitMatchesFitment !== 'function') return false;
    if (window.kitMatchesFitment(product, matcherForParsedVehicle(vehicle))) return true;
    if (!vehicle.engineSoft) return false;
    if (!window.kitMatchesFitment(product, {
      year: vehicle.year,
      model: vehicle.model,
      engine: 'All',
      submodel: 'All',
      modelKey: vehicle.model
    })) return false;
    var hay = product._q || productSearchText(product);
    return tokenDirectMatches(product, hay, vehicle.engineSoft);
  }

  function vehicleIgnoreTokens() {
    var ignore = {};
    var vehicle = state.vehicle || {};
    var bits = [
      vehicle.label,
      vehicle.ymm,
      vehicle.year,
      vehicle.make,
      vehicle.model,
      vehicle.engine,
      vehicle.modelKey,
      vehicle.fitment,
      state.engine
    ];
    rawSearchTokens(bits.join(' ')).forEach(function (token) {
      ignore[token] = true;
    });
    return ignore;
  }

  function searchTokens(query) {
    var ignore = vehicleIgnoreTokens();
    return rawSearchTokens(query).filter(function (token) {
      return !SEARCH_STOP[token] && !ignore[token];
    });
  }

  function tokenMatches(hay, token) {
    if (!hay || !token) return false;
    if (hay.indexOf(token) !== -1) return true;
    if (token.length > 4 && token.charAt(token.length - 1) === 's' && hay.indexOf(token.slice(0, -1)) !== -1) {
      return true;
    }
    if (token.indexOf('-') === -1 && hay.indexOf('-') === -1) return false;
    var hayOpen = hay.replace(/-/g, '');
    var tokenOpen = token.replace(/-/g, '');
    if (tokenOpen && hayOpen.indexOf(tokenOpen) !== -1) return true;
    if (tokenOpen.length > 4 && tokenOpen.charAt(tokenOpen.length - 1) === 's' && hayOpen.indexOf(tokenOpen.slice(0, -1)) !== -1) {
      return true;
    }
    return false;
  }

  function productTypeListMatches(product, token) {
    var values = productTypeList(product);
    var i;
    for (i = 0; i < values.length; i++) {
      if (tokenMatches(values[i].toLowerCase(), token)) return true;
    }
    return false;
  }

  function yearSpanFromToken(token) {
    var match = String(token || '').match(/^(\d{4})-(\d{4})$/);
    if (!match) return null;
    var start = parseInt(match[1], 10);
    var end = parseInt(match[2], 10);
    if (!start || !end || end < start || end - start > 40) return null;
    return { start: start, end: end };
  }

  function isSearchYearToken(token) {
    return /^(19|20)\d{2}$/.test(token);
  }

  function tokenDirectMatches(product, hay, token) {
    var span = yearSpanFromToken(token);
    if (span && productOverlapsYearSpan(product, span.start, span.end)) return true;
    if (isSearchYearToken(token) && productFitmentYears(product)[parseInt(token, 10)]) return true;
    if (tokenMatches(hay, token)) return true;
    return productTypeListMatches(product, token);
  }

  function tokenOrFitmentMatches(product, hay, token) {
    if (tokenDirectMatches(product, hay, token)) return true;
    var alts = SEARCH_SYNONYMS[token];
    if (!alts) return false;
    var i;
    for (i = 0; i < alts.length; i++) {
      if (tokenDirectMatches(product, hay, alts[i])) return true;
    }
    return false;
  }

  function skuMatches(product, query) {
    var compact = String(query || '').toLowerCase().replace(/[\s\-]/g, '');
    if (!compact) return false;
    var skus = productSkuList(product);
    var i;
    var skuCompact;
    for (i = 0; i < skus.length; i++) {
      skuCompact = skus[i].replace(/[\s\-]/g, '');
      if (skuCompact === compact) return true;
      if (compact.length >= 4 && skuCompact.indexOf(compact) !== -1) return true;
    }
    return false;
  }

  function productIsStaffPick(product) {
    if (!product) return false;
    if (product.staffPick === true) return true;
    var variants = product.variants || [];
    var i;
    for (i = 0; i < variants.length; i++) {
      if (variants[i] && variants[i].staffPick === true) return true;
    }
    return false;
  }

  function catalogIndex(product) {
    var index = product && product._catalogIndex;
    return typeof index === 'number' ? index : 0;
  }

  function fieldTokenScore(field, token) {
    if (!field || !token || !tokenMatches(field, token)) return 0;
    if (field === token) return 100;
    if (field.indexOf(token) === 0) return 90;
    if (field.indexOf(' ' + token) !== -1) return 80;
    return 50;
  }

  function searchMatchScore(product, tokens, raw) {
    var score = 0;
    if (skuMatches(product, raw)) score += 100000;
    var title = String(product.title || '').toLowerCase();
    var vendor = String(product.vendor || '').toLowerCase();
    var type = String(product.type || '').toLowerCase();
    var lists = productTypeList(product).join(' ').toLowerCase();
    var handle = String(product.handle || '').toLowerCase();
    var i;
    var token;
    var best;
    for (i = 0; i < tokens.length; i++) {
      token = tokens[i];
      best = fieldTokenScore(title, token) * 10;
      if (!best) best = Math.max(fieldTokenScore(vendor, token), fieldTokenScore(type, token)) * 4;
      if (!best) best = fieldTokenScore(lists, token) * 3;
      if (!best) best = fieldTokenScore(handle, token) * 2;
      if (!best) best = 1;
      score += best;
    }
    return score;
  }

  function sortBrowseProducts(list, query) {
    var plan = querySearchPlan(query);
    var tokens = plan.tokens;
    var scored = list.slice();
    if (plan.raw) {
      scored.sort(function (a, b) {
        var sa = searchMatchScore(a, tokens, plan.raw);
        var sb = searchMatchScore(b, tokens, plan.raw);
        if (sb !== sa) return sb - sa;
        var ja = productIsStaffPick(a) ? 1 : 0;
        var jb = productIsStaffPick(b) ? 1 : 0;
        if (jb !== ja) return jb - ja;
        return catalogIndex(a) - catalogIndex(b);
      });
      return scored;
    }
    scored.sort(function (a, b) {
      var ja = productIsStaffPick(a) ? 1 : 0;
      var jb = productIsStaffPick(b) ? 1 : 0;
      if (jb !== ja) return jb - ja;
      return catalogIndex(a) - catalogIndex(b);
    });
    return scored;
  }

  function searchProducts(query, pool) {
    var plan = querySearchPlan(query);
    if (!plan.raw) return [];
    var source = pool || ensureSearchPool();
    var list = plan.vehicle
      ? source.filter(function (product) {
        return productMatchesParsedVehicle(product, plan.vehicle);
      })
      : source;
    var tokens = plan.tokens;
    var out = [];
    var seen = {};
    var i;
    var product;

    for (i = 0; i < source.length; i++) {
      product = source[i];
      if (skuMatches(product, plan.raw)) {
        seen[product.id] = true;
        out.push(product);
      }
    }

    if (!tokens.length) {
      if (plan.vehicle) {
        for (i = 0; i < list.length; i++) {
          if (!seen[list[i].id]) out.push(list[i]);
        }
      }
      return out;
    }

    function matchesTokens(product, needed) {
      var haystack = product._q || productSearchText(product);
      var n;
      for (n = 0; n < needed.length; n++) {
        if (!tokenOrFitmentMatches(product, haystack, needed[n])) return false;
      }
      return true;
    }

    var position = tokens.filter(function (token) { return SEARCH_POSITION[token]; });
    var required = tokens.filter(function (token) { return !SEARCH_POSITION[token]; });
    if (!required.length) required = tokens.slice();

    for (i = 0; i < list.length; i++) {
      product = list[i];
      if (seen[product.id]) continue;
      if (matchesTokens(product, tokens)) out.push(product);
    }

    if (!out.length && position.length && required.length < tokens.length) {
      for (i = 0; i < list.length; i++) {
        product = list[i];
        if (seen[product.id]) continue;
        if (matchesTokens(product, required)) out.push(product);
      }
    }
    return out;
  }

  function hasSearchQuery() {
    return String(state.query || '').trim().length > 0;
  }

  function browseSourceProducts() {
    if (state.mode === 'search') {
      return hasSearchQuery() ? searchProducts(state.query) : [];
    }
    var inCategory = categoryProducts();
    if (!hasSearchQuery()) return inCategory;
    return searchProducts(state.query, inCategory);
  }

  function filteredProducts() {
    var list = browseSourceProducts().filter(function (product) {
      if (state.vendor && product.vendor !== state.vendor) return false;
      if (state.subType && productSubTypes(product).indexOf(state.subType) === -1) return false;
      if (state.mode === 'category' && state.engine && !productMatchesEngine(product, state.engine)) return false;
      return true;
    });
    return sortBrowseProducts(list, hasSearchQuery() ? state.query : '');
  }

  function vehicleFromRow(row) {
    if (!row) return null;
    return {
      ymm: row.ymm,
      year: String(row.year || ''),
      make: row.make,
      model: row.model,
      engine: row.engine,
      modelKey: row.modelKey || ((row.model || '') + ' ' + (row.engine || '')).trim(),
      label: row.label || [row.year, row.make, row.model, row.engine].filter(Boolean).join(' '),
      fitment: row.fitment || ''
    };
  }

  function sortedKeys(obj) {
    return Object.keys(obj || {}).sort(function (a, b) {
      var na = Number(a);
      var nb = Number(b);
      if (!isNaN(na) && !isNaN(nb) && String(na) === a && String(nb) === b) return nb - na;
      return a.localeCompare(b);
    });
  }

  function buildYmmIndex(rows) {
    ymmIndex = {};
    ymmInfoByModelKey = {};
    ymmMakesByModel = {};
    (Array.isArray(rows) ? rows : []).forEach(function (row) {
      if (!row) return;
      var year = String(row.year || '').trim();
      var make = String(row.make || DEFAULT_MAKE).trim();
      var model = String(row.model || '').trim();
      var engine = String(row.engine || '').trim();
      if (!year || !make || !model || !engine) return;
      if (!ymmIndex[year]) ymmIndex[year] = {};
      if (!ymmIndex[year][make]) ymmIndex[year][make] = {};
      if (!ymmIndex[year][make][model]) ymmIndex[year][make][model] = {};
      ymmIndex[year][make][model][engine] = row;

      var modelKey = String(row.modelKey || (model + ' ' + engine)).trim();
      var keyLower = modelKey.toLowerCase();
      if (!ymmInfoByModelKey[keyLower]) {
        ymmInfoByModelKey[keyLower] = { makes: {}, model: model, engine: engine };
      }
      ymmInfoByModelKey[keyLower].makes[make] = true;
      if (!ymmMakesByModel[model.toLowerCase()]) ymmMakesByModel[model.toLowerCase()] = {};
      ymmMakesByModel[model.toLowerCase()][make] = true;
    });
    buildYmmSearchIndex();
  }

  function buildYmmSearchIndex() {
    var makeSeen = {};
    var modelSeen = {};
    var engineSeen = {};
    ymmSearch.makes = [];
    ymmSearch.models = [];
    ymmSearch.engines = [];
    ymmRowsAll.forEach(function (row) {
      if (!row) return;
      var make = String(row.make || '').trim();
      var model = String(row.model || '').trim();
      var engine = String(row.engine || '').trim();
      if (make && !makeSeen[make.toLowerCase()]) {
        makeSeen[make.toLowerCase()] = true;
        ymmSearch.makes.push({
          name: make,
          key: make.toLowerCase(),
          tokens: rawSearchTokens(make)
        });
      }
      if (model && !modelSeen[model.toLowerCase()]) {
        modelSeen[model.toLowerCase()] = true;
        var tokens = rawSearchTokens(model);
        ymmSearch.models.push({
          name: model,
          key: model.toLowerCase(),
          tokens: tokens,
          tokenCount: tokens.length
        });
      }
      if (engine && !engineSeen[engine.toLowerCase()]) {
        engineSeen[engine.toLowerCase()] = true;
        ymmSearch.engines.push(engine);
      }
    });
    ymmSearch.models.sort(function (a, b) {
      if (b.tokenCount !== a.tokenCount) return b.tokenCount - a.tokenCount;
      return b.key.length - a.key.length;
    });
  }

  function fillSelect(select, placeholder, names) {
    if (!select) return;
    select.innerHTML = '<option value="">' + escapeHtml(placeholder) + '</option>';
    (names || []).forEach(function (name) {
      var option = document.createElement('option');
      option.value = name;
      option.textContent = name;
      select.appendChild(option);
    });
  }

  function readLastVehicle() {
    try {
      var raw = window.localStorage.getItem(LAST_VEHICLE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || !data.year || !data.make || !data.model) return null;
      return {
        year: String(data.year),
        make: String(data.make),
        model: String(data.model),
        engine: String(data.engine || '')
      };
    } catch (err) {
      return null;
    }
  }

  function writeLastVehicle(vehicle) {
    if (!vehicle || !vehicle.year || !vehicle.make || !vehicle.model) return;
    try {
      window.localStorage.setItem(LAST_VEHICLE_KEY, JSON.stringify({
        year: vehicle.year,
        make: vehicle.make,
        model: vehicle.model,
        engine: vehicle.engine || ''
      }));
    } catch (err) {
      /* private mode / quota — fail silent */
    }
  }

  function restoreLastVehicle() {
    var saved = readLastVehicle();
    if (!saved || !yearEl || !ymmIndex[saved.year]) return;
    yearEl.value = saved.year;
    fillMakes();
    if (!makeEl || !ymmIndex[saved.year][saved.make]) return;
    makeEl.value = saved.make;
    fillModels();
    if (!modelEl || !ymmIndex[saved.year][saved.make][saved.model]) return;
    modelEl.value = saved.model;
    fillEngines();
    if (
      saved.engine &&
      engineEl &&
      ymmIndex[saved.year][saved.make][saved.model][saved.engine]
    ) {
      engineEl.value = saved.engine;
    }
  }

  function fillYears() {
    fillSelect(yearEl, 'Select Year', sortedKeys(ymmIndex));
    fillMakes();
  }

  function fillMakes() {
    var year = yearEl ? yearEl.value : '';
    var makes = year && ymmIndex[year] ? Object.keys(ymmIndex[year]).sort() : [];
    fillSelect(makeEl, 'Select Make', makes);
    if (makeEl) makeEl.disabled = !makes.length;
    if (makes.length === 1 && makeEl) makeEl.value = makes[0];
    fillModels();
  }

  function fillModels() {
    var year = yearEl ? yearEl.value : '';
    var make = makeEl ? makeEl.value : '';
    var modelsMap = year && make && ymmIndex[year] && ymmIndex[year][make] ? ymmIndex[year][make] : {};
    var names = Object.keys(modelsMap).sort();
    fillSelect(modelEl, 'Select Model', names);
    if (modelEl) modelEl.disabled = !names.length;
    if (names.length === 1 && modelEl) modelEl.value = names[0];
    fillEngines();
  }

  function fillEngines() {
    var year = yearEl ? yearEl.value : '';
    var make = makeEl ? makeEl.value : '';
    var model = modelEl ? modelEl.value : '';
    var enginesMap = year && make && model && ymmIndex[year] && ymmIndex[year][make] && ymmIndex[year][make][model]
      ? ymmIndex[year][make][model]
      : {};
    var names = Object.keys(enginesMap).sort();
    fillSelect(engineEl, names.length ? 'All engines' : 'Select Engine', names);
    if (engineEl) engineEl.disabled = !names.length;
    if (names.length === 1 && engineEl) engineEl.value = names[0];
  }

  function getSelectedVehicle() {
    var year = yearEl ? yearEl.value : '';
    var make = makeEl ? makeEl.value : '';
    var model = modelEl ? modelEl.value : '';
    var engine = engineEl ? engineEl.value : '';
    if (!year || !make || !model) return null;
    if (engine) {
      var row = ymmIndex[year] &&
        ymmIndex[year][make] &&
        ymmIndex[year][make][model] &&
        ymmIndex[year][make][model][engine];
      return row ? vehicleFromRow(row) : null;
    }
    return {
      ymm: [year, make, model].join('_'),
      year: year,
      make: make,
      model: model,
      engine: '',
      modelKey: model,
      label: [year, make, model].join(' '),
      fitment: ''
    };
  }

  function setNotice(message, isError) {
    if (!noticeEl) return;
    noticeEl.textContent = message || '';
    noticeEl.classList.toggle('is-error', !!isError && !!message);
  }

  function setScreen(name) {
    state.screen = name;
    root.querySelectorAll('[data-sr-screen]').forEach(function (screen) {
      var active = screen.getAttribute('data-sr-screen') === name;
      screen.classList.toggle('is-active', active);
      screen.hidden = !active;
    });
    if (backEl) {
      backEl.hidden = name === 'ymm';
      if (backLabelEl) {
        backLabelEl.textContent = name === 'products' && state.vehicle && !state.allProducts
          ? 'Categories'
          : 'Vehicle';
      }
    }
  }

  function setVehicleLabels() {
    var label = vehicleLabel();
    vehicleEls.forEach(function (el) {
      el.textContent = label;
    });
  }

  function buildCategories() {
    var list = vehicleProducts();
    var buckets = {};

    list.forEach(function (product) {
      productPartTypes(product).forEach(function (category) {
        if (isHiddenPartType(category) || promotedSubtype(category)) return;
        if (!buckets[category]) {
          buckets[category] = {
            name: category,
            kind: 'part',
            count: 0,
            image: categoryImageForKey(partTypeImageKey(category))
          };
        }
        buckets[category].count += 1;
        if (!buckets[category].image && product.image) {
          buckets[category].image = absUrl(product.image);
        }
      });
    });

    PROMOTED_SUBTYPES.forEach(function (tile) {
      var count = 0;
      list.forEach(function (product) {
        if (productSubTypes(product).indexOf(tile.value) !== -1) count += 1;
      });
      if (!count) return;
      buckets[tile.value] = {
        name: tile.value,
        kind: 'sub',
        count: count,
        image: CATEGORY_IMAGES[tile.imageKey] || ''
      };
    });

    return Object.keys(buckets)
      .sort(function (a, b) {
        if (a === OTHER_CATEGORY) return 1;
        if (b === OTHER_CATEGORY) return -1;
        var aBucket = buckets[a];
        var bBucket = buckets[b];
        var aKey = aBucket.kind === 'sub'
          ? (promotedSubtype(a) && promotedSubtype(a).imageKey) || partTypeImageKey(a)
          : partTypeImageKey(a);
        var bKey = bBucket.kind === 'sub'
          ? (promotedSubtype(b) && promotedSubtype(b).imageKey) || partTypeImageKey(b)
          : partTypeImageKey(b);
        var aSort = categorySortIndex(aKey);
        var bSort = categorySortIndex(bKey);
        if (aSort !== bSort) return aSort - bSort;
        return a.localeCompare(b);
      })
      .map(function (key) {
        return buckets[key];
      });
  }

  function searchTileHtml() {
    return (
      '<button type="button" class="fh-sr-cat fh-sr-cat--search" data-sr-search-tile>' +
        '<span class="fh-sr-cat__icon" aria-hidden="true">' +
          '<svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="6.5" fill="none" stroke="currentColor" stroke-width="2"/><path d="M16 16l5 5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
        '</span>' +
        '<span class="fh-sr-cat__label">' +
          'Shop By Search' +
          '<span class="fh-sr-cat__meta">Name, brand, year, or type</span>' +
        '</span>' +
      '</button>'
    );
  }

  function renderCategories() {
    setVehicleLabels();
    if (!catsEl) return;
    var list = buildCategories();
    if (catsEmptyEl) catsEmptyEl.hidden = list.length > 0;
    catsEl.innerHTML = searchTileHtml() + list.map(function (bucket) {
      var img = bucket.image
        ? '<img src="' + escapeHtml(bucket.image) + '" alt="" loading="lazy">'
        : '';
      var bg = bucket.image ? ' style="background-image:url(\'' + escapeHtml(bucket.image) + '\')"' : '';
      return (
        '<button type="button" class="fh-sr-cat" data-sr-category="' + escapeHtml(bucket.name) + '"' + bg + '>' +
          img +
          '<span class="fh-sr-cat__label">' +
            escapeHtml(bucket.name) +
            '<span class="fh-sr-cat__meta">' + bucket.count + (bucket.count === 1 ? ' item' : ' items') + '</span>' +
          '</span>' +
        '</button>'
      );
    }).join('');
  }

  function renderVendorOptions() {
    if (!vendorEl) return;
    var vendors = uniqueSorted(browseSourceProducts().map(function (product) {
      return product.vendor;
    }));
    if (state.vendor && vendors.indexOf(state.vendor) === -1) state.vendor = '';
    fillSelect(vendorEl, 'All brands', vendors);
    vendorEl.value = state.vendor || '';
  }

  function renderTypePills() {
    var source = browseSourceProducts().filter(function (product) {
      return !state.vendor || product.vendor === state.vendor;
    });
    var types = uniqueSorted(source.reduce(function (acc, product) {
      return acc.concat(productSubTypes(product));
    }, []));
    var showTypes = types.length > 0;
    if (state.mode === 'search') {
      showTypes = types.length > 0 && (isPhone() || types.length <= SEARCH_TYPE_PILL_MAX);
    }
    if (typeFilterEl) typeFilterEl.hidden = !showTypes;
    if (!showTypes) {
      if (state.mode === 'search') state.subType = '';
      if (typesEl) typesEl.innerHTML = '';
      fillSelect(typeSelectEl, 'All', []);
      return;
    }
    if (state.subType && types.indexOf(state.subType) === -1) state.subType = '';
    fillSelect(typeSelectEl, 'All', types);
    if (typeSelectEl) typeSelectEl.value = state.subType || '';
    if (!typesEl) return;
    var html = '<button type="button" class="fh-sr-pill' + (!state.subType ? ' is-active' : '') + '" data-sr-type="">All</button>';
    html += types.map(function (type) {
      return (
        '<button type="button" class="fh-sr-pill' + (state.subType === type ? ' is-active' : '') + '" data-sr-type="' +
        escapeHtml(type) + '">' + escapeHtml(type) + '</button>'
      );
    }).join('');
    typesEl.innerHTML = html;
  }

  function renderEnginePills() {
    if (!engineFilterEl) return;
    if (!showEngineFilter()) {
      engineFilterEl.hidden = true;
      if (enginesEl) enginesEl.innerHTML = '';
      fillSelect(engineSelectEl, 'All', []);
      return;
    }
    var source = browseSourceProducts();
    var engines = vehicleEngines().filter(function (engine) {
      return engine === state.engine || source.some(function (product) {
        return productMatchesEngine(product, engine);
      });
    });
    if (!engines.length) {
      engineFilterEl.hidden = true;
      if (enginesEl) enginesEl.innerHTML = '';
      fillSelect(engineSelectEl, 'All', []);
      return;
    }
    if (state.engine && engines.indexOf(state.engine) === -1) state.engine = '';
    engineFilterEl.hidden = false;
    fillSelect(engineSelectEl, 'All', engines);
    if (engineSelectEl) engineSelectEl.value = state.engine || '';
    if (!enginesEl) return;
    var html = '<button type="button" class="fh-sr-pill' + (!state.engine ? ' is-active' : '') + '" data-sr-engine-size="">All</button>';
    html += engines.map(function (engine) {
      return (
        '<button type="button" class="fh-sr-pill' + (state.engine === engine ? ' is-active' : '') + '" data-sr-engine-size="' +
        escapeHtml(engine) + '">' + escapeHtml(engine) + '</button>'
      );
    }).join('');
    enginesEl.innerHTML = html;
  }

  function searchIdleImages() {
    var seen = {};
    var out = [];
    function add(image, name) {
      var src = absUrl(image);
      if (!src || seen[src] || out.length >= 8) return;
      seen[src] = true;
      out.push({ image: src, name: name || '' });
    }
    buildCategories().forEach(function (bucket) {
      add(bucket.image, bucket.name);
    });
    if (out.length < 4) {
      vehicleProducts().forEach(function (product) {
        add(product.image, productPartTypes(product)[0] || '');
      });
    }
    return out;
  }

  function renderSearchIdle() {
    if (!searchIdleTilesEl) return;
    var key = vehicleKey();
    if (searchIdleKey === key && searchIdleTilesEl.childNodes.length) return;
    searchIdleTilesEl.innerHTML = searchIdleImages().map(function (tile) {
      return (
        '<div class="fh-sr-search-idle__tile">' +
          '<img src="' + escapeHtml(tile.image) + '" alt="" draggable="false">' +
          (tile.name ? '<span>' + escapeHtml(tile.name) + '</span>' : '') +
        '</div>'
      );
    }).join('');
    searchIdleKey = key;
  }

  function setSearchIdle(on) {
    if (browseEl) browseEl.classList.toggle('is-search-idle', !!on);
    if (searchIdleEl) searchIdleEl.hidden = !on;
    if (on) renderSearchIdle();
  }

  function syncBrowseMode() {
    var isSearch = state.mode === 'search';
    if (browseEl) browseEl.classList.toggle('is-search', isSearch);
    if (railSearchEl) railSearchEl.hidden = false;
    if (railFiltersEl) railFiltersEl.hidden = isSearch && !hasSearchQuery();
    if (searchEl) {
      searchEl.placeholder = isSearch ? 'Name, brand, year, or type' : 'Search this category';
    }
  }

  function renderProductCards(list) {
    return list.map(function (product) {
      var src = absUrl(product.image);
      var mediaStyle = src ? ' style="background-image:url(\'' + escapeHtml(src) + '\')"' : '';
      var img = src
        ? '<img src="' + escapeHtml(src) + '" alt="' + escapeHtml(product.title) + '">'
        : '<span class="fh-sr-card__ph" aria-hidden="true"></span>';
      var joeBadge = productIsStaffPick(product)
        ? '<span class="fh-sr-card__joe-badge">Joe Approved</span>'
        : '';
      return (
        '<button type="button" class="fh-sr-card" data-sr-details="' + escapeHtml(String(product.id)) + '">' +
          '<span class="fh-sr-card__inner">' +
            '<span class="fh-sr-card__media"' + mediaStyle + '>' + joeBadge + img + '</span>' +
            '<span class="fh-sr-card__copy">' +
              '<span class="fh-sr-card__title"><span class="fh-sr-card__title-text">' + escapeHtml(product.title) + '</span></span>' +
              '<span class="fh-sr-card__price">' + formatPrice(product) + '</span>' +
            '</span>' +
          '</span>' +
        '</button>'
      );
    }).join('');
  }

  function resetGridPage() {
    state.visibleCount = GRID_PAGE_SIZE;
  }

  function setLoadMoreVisible(visible) {
    if (moreEl) moreEl.hidden = !visible;
  }

  function renderProducts(opts) {
    var append = !!(opts && opts.append);
    var isSearch = state.mode === 'search';
    if (isSearch && state.allProducts && hasSearchQuery()) {
      state.queryVehicle = querySearchPlan(state.query).vehicle;
    } else if (!hasSearchQuery() || !state.allProducts) {
      state.queryVehicle = null;
    }
    syncBrowseMode();
    if (railTitleEl) railTitleEl.textContent = isSearch ? 'Search' : (state.category || '');
    setVehicleLabels();
    if (!isSearch || hasSearchQuery()) {
      renderVendorOptions();
      renderTypePills();
      renderEnginePills();
    } else {
      if (typeFilterEl) typeFilterEl.hidden = true;
      if (engineFilterEl) engineFilterEl.hidden = true;
    }

    if (!gridEl) return;
    if (isSearch && !hasSearchQuery()) {
      state.vendor = '';
      state.subType = '';
      state.visibleCount = GRID_PAGE_SIZE;
      gridEl.innerHTML = '';
      if (countEl) countEl.textContent = '';
      if (emptyEl) emptyEl.hidden = true;
      setLoadMoreVisible(false);
      setSearchIdle(true);
      return;
    }

    setSearchIdle(false);

    var list = filteredProducts();
    var limit = state.visibleCount || GRID_PAGE_SIZE;
    if (limit < GRID_PAGE_SIZE) limit = GRID_PAGE_SIZE;
    state.visibleCount = limit;
    var shown = list.slice(0, limit);

    if (countEl) {
      countEl.textContent = shown.length < list.length
        ? 'Showing ' + shown.length + ' of ' + list.length + ' products'
        : list.length + (list.length === 1 ? ' product' : ' products');
    }

    if (!list.length) {
      gridEl.innerHTML = '';
      setLoadMoreVisible(false);
      if (emptyEl) {
        emptyEl.hidden = false;
        emptyEl.textContent = hasSearchQuery()
          ? 'No products match this search.'
          : 'No products match these filters.';
      }
      return;
    }
    if (emptyEl) emptyEl.hidden = true;

    if (append && gridEl.children.length) {
      var already = gridEl.querySelectorAll('[data-sr-details]').length;
      if (already < shown.length) {
        gridEl.insertAdjacentHTML('beforeend', renderProductCards(list.slice(already, shown.length)));
      }
    } else {
      gridEl.innerHTML = renderProductCards(shown);
    }
    setLoadMoreVisible(shown.length < list.length);
  }

  function findProductById(id) {
    var target = String(id || '');
    for (var i = 0; i < products.length; i++) {
      if (String(products[i].id) === target) return products[i];
    }
    return null;
  }

  function productImages(product) {
    var images = Array.isArray(product.images) ? product.images.filter(Boolean).map(absUrl) : [];
    if (!images.length && product.image) images = [absUrl(product.image)];
    return images;
  }

  function formatPrice(product, variant) {
    var price = variant && variant.price ? variant.price : product.price || '';
    var compare = variant && variant.compareAt ? variant.compareAt : product.compareAt || '';
    var priceCents = variant && variant.priceCents != null ? variant.priceCents : product.priceCents;
    var compareCents = variant && variant.compareAtCents != null ? variant.compareAtCents : product.compareAtCents;
    if (compare && compareCents && priceCents && compareCents > priceCents) {
      return escapeHtml(price) + ' <s>' + escapeHtml(compare) + '</s>';
    }
    return escapeHtml(price);
  }

  function setLightboxTab(tab) {
    var next = tab === 'fitment' ? 'fitment' : 'details';
    state.lightboxTab = next;
    if (lightboxTabsEl) {
      lightboxTabsEl.querySelectorAll('[data-sr-lightbox-tab]').forEach(function (button) {
        var active = button.getAttribute('data-sr-lightbox-tab') === next;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }
    if (lightboxDescEl) lightboxDescEl.hidden = next !== 'details';
    if (lightboxFitmentEl) lightboxFitmentEl.hidden = next !== 'fitment';
    if (lightboxScrollEl) lightboxScrollEl.scrollTop = 0;
  }

  function productIsSuspensionKit(product) {
    return productSubTypes(product).indexOf('Suspension Kits') !== -1;
  }

  function setLightboxDetails(html, extraTableHtml) {
    if (!lightboxDescEl) return;
    var cleaned = String(html || '').trim();
    var body = cleaned || '<p>No details available for this product.</p>';
    var table = String(extraTableHtml || '').trim();
    if (table) {
      body += '<div class="fh-sr-lightbox__suspension product-fitment-table">' + table + '</div>';
    }
    lightboxDescEl.innerHTML = body;
    if (table) {
      sanitizeFitmentHtml(lightboxDescEl);
      sanitizeSuspensionHtml(lightboxDescEl);
      Array.prototype.forEach.call(
        lightboxDescEl.querySelectorAll('.fh-sr-lightbox__suspension'),
        revealAllSuspensionRows
      );
    }
  }

  function detailsTableFor(product) {
    return productIsSuspensionKit(product) ? (product.suspensionTable || '') : '';
  }

  function sanitizeFitmentHtml(root) {
    if (!root) return;
    var tables = root.querySelectorAll('#cm-fitment-table, .cm_fitment-table, .product-fitment-table-content');
    Array.prototype.forEach.call(tables, function (table) {
      if (table.id === 'cm-fitment-table') {
        table.removeAttribute('id');
        table.classList.add('product-fitment-table-content');
      }
      Array.prototype.forEach.call(
        table.querySelectorAll('[class*="cmTemplate"], [class*="cmRepeater"]'),
        function (el) {
          Array.prototype.slice.call(el.classList).forEach(function (cls) {
            if (cls.indexOf('cmTemplate') === 0 || cls.indexOf('cmRepeater') === 0) {
              el.classList.remove(cls);
            }
          });
        }
      );
      Array.prototype.forEach.call(
        table.querySelectorAll('.collapsed, [style*="height"], [style*="overflow"], [style*="max-height"]'),
        function (el) {
          el.classList.remove('collapsed');
          el.removeAttribute('style');
        }
      );
    });
    Array.prototype.forEach.call(root.querySelectorAll('.cm_fitment-table__horizontal, .fitment-table-container'), function (horizontal) {
      var bodies = horizontal.querySelectorAll('.fitment-table-fitment');
      if (bodies.length < 2) return;
      var primary = bodies[0];
      var i;
      for (i = 1; i < bodies.length; i++) {
        var extra = bodies[i];
        while (extra.firstChild) primary.appendChild(extra.firstChild);
        if (extra.parentNode) extra.parentNode.removeChild(extra);
      }
      primary.classList.remove('collapsed');
      primary.removeAttribute('style');
    });
    Array.prototype.forEach.call(
      root.querySelectorAll('.cm_collapsible-elem, [class*="initiallyHidden"], .fitment-table-fitment, .fitment-table-body'),
      function (el) {
        el.classList.remove('collapsed');
        if (el.hasAttribute('style')) el.removeAttribute('style');
        if (el.getAttribute('aria-hidden') === 'true') el.removeAttribute('aria-hidden');
      }
    );
  }

  function revealAllFitmentRows(tableWrapper) {
    if (!tableWrapper) return;
    tableWrapper.setAttribute('data-fitment-initialized', 'true');
    Array.prototype.forEach.call(
      tableWrapper.querySelectorAll('.fitment-row.fitment-row--hidden'),
      function (row) { row.classList.remove('fitment-row--hidden'); }
    );
    Array.prototype.forEach.call(
      tableWrapper.querySelectorAll('.fitment-view-more-wrapper'),
      function (el) { if (el.parentNode) el.parentNode.removeChild(el); }
    );
  }

  function sanitizeSuspensionHtml(root) {
    if (!root) return;
    var tables = root.querySelectorAll('#cm-suspension-table, .cm_suspension_table, .suspension-table-container');
    Array.prototype.forEach.call(tables, function (table) {
      if (table.id === 'cm-suspension-table') {
        table.removeAttribute('id');
        table.classList.add('cm_suspension_table');
      }
      Array.prototype.forEach.call(
        table.querySelectorAll('.collapsed, [style*="height"], [style*="overflow"], [style*="max-height"]'),
        function (el) {
          el.classList.remove('collapsed');
          el.removeAttribute('style');
        }
      );
    });
  }

  function revealAllSuspensionRows(tableWrapper) {
    if (!tableWrapper) return;
    tableWrapper.setAttribute('data-suspension-initialized', 'true');
    Array.prototype.forEach.call(
      tableWrapper.querySelectorAll('.suspension-row.suspension-row--hidden'),
      function (row) { row.classList.remove('suspension-row--hidden'); }
    );
    Array.prototype.forEach.call(
      tableWrapper.querySelectorAll('.suspension-view-more-wrapper'),
      function (el) { if (el.parentNode) el.parentNode.removeChild(el); }
    );
  }

  function setLightboxFitment(html) {
    if (!lightboxFitmentEl) return;
    var raw = String(html || '').trim();
    if (!raw) {
      lightboxFitmentEl.innerHTML = '';
      if (lightboxTabsEl) lightboxTabsEl.hidden = true;
      setLightboxTab('details');
      return;
    }
    lightboxFitmentEl.innerHTML = '<div class="product-fitment-table">' + raw + '</div>';
    sanitizeFitmentHtml(lightboxFitmentEl);
    Array.prototype.forEach.call(
      lightboxFitmentEl.querySelectorAll('.product-fitment-table'),
      revealAllFitmentRows
    );
    if (lightboxTabsEl) lightboxTabsEl.hidden = false;
  }

  function renderReviews(product) {
    if (!lightboxReviewsEl) return;
    var count = Number(product && product.ratingCount ? product.ratingCount : 0);
    var rating = Number(product && product.rating ? product.rating : 0);
    if (!count) {
      lightboxReviewsEl.hidden = true;
      lightboxReviewsEl.removeAttribute('aria-label');
      lightboxReviewsEl.innerHTML = '';
      return;
    }
    var stars = '<span class="fh-sr-stars" aria-hidden="true">';
    for (var i = 1; i <= 5; i++) {
      var fill = Math.max(0, Math.min(1, rating - (i - 1)));
      stars +=
        '<span class="fh-sr-star">' +
          '<span class="fh-sr-star__base">' + STAR_SVG + '</span>' +
          '<span class="fh-sr-star__fill" style="width:' + (fill * 100) + '%">' + STAR_SVG + '</span>' +
        '</span>';
    }
    stars += '</span>';
    lightboxReviewsEl.innerHTML =
      stars +
      '<span class="fh-sr-lightbox__reviews-count">' +
        count + (count === 1 ? ' review' : ' reviews') +
      '</span>';
    lightboxReviewsEl.setAttribute(
      'aria-label',
      (rating ? rating.toFixed(1) + ' out of 5 from ' : '') + count + (count === 1 ? ' review' : ' reviews')
    );
    lightboxReviewsEl.hidden = false;
  }

  function renderLightboxThumbs(product) {
    if (!lightboxThumbsEl) return;
    var images = productImages(product);
    if (images.length > 1) {
      lightboxThumbsEl.hidden = false;
      lightboxThumbsEl.innerHTML = images.map(function (src, index) {
        return (
          '<button type="button" class="' + (index === 0 ? 'is-active' : '') + '" data-sr-thumb="' + escapeHtml(src) + '">' +
            '<img src="' + escapeHtml(src) + '" alt="">' +
          '</button>'
        );
      }).join('');
    } else {
      lightboxThumbsEl.innerHTML = '';
      lightboxThumbsEl.hidden = true;
    }
  }

  function parseJsonResponse(res) {
    if (!res.ok) throw new Error('product');
    return res.text().then(function (text) {
      return JSON.parse(text);
    });
  }

  function fetchProductDetail(product) {
    var handle = product && product.handle ? product.handle : '';
    if (!handle) return Promise.reject(new Error('handle'));
    return fetch('/products/' + encodeURIComponent(handle) + '?view=showroom-json', { credentials: 'same-origin' })
      .then(parseJsonResponse);
  }

  function applyProductDetail(product, detail) {
    if (!detail) return;
    product.shortDescription = detail.shortDescription || '';
    product.table = detail.table || '';
    product.suspensionTable = detail.suspensionTable || '';
    product.detailLoaded = true;
    if (Array.isArray(detail.images) && detail.images.length) {
      product.images = detail.images;
    }
    setLightboxDetails(product.shortDescription, detailsTableFor(product));
    setLightboxFitment(product.table);
  }

  function setLightboxImage(src, alt) {
    if (!lightboxImageEl) return;
    if (src) {
      lightboxImageEl.src = src;
      lightboxImageEl.alt = alt || '';
      lightboxImageEl.style.display = '';
    } else {
      lightboxImageEl.removeAttribute('src');
      lightboxImageEl.alt = '';
      lightboxImageEl.style.display = 'none';
    }
  }

  function closeLightbox() {
    if (!lightboxEl) return;
    lightboxEl.classList.remove('is-open');
    lightboxEl.hidden = true;
    if (lightboxLastFocus && typeof lightboxLastFocus.focus === 'function') {
      lightboxLastFocus.focus();
    }
    lightboxLastFocus = null;
  }

  function openLightbox(productId) {
    var product = findProductById(productId);
    if (!product || !lightboxEl) return;
    state.lightboxProductId = product.id;
    lightboxLastFocus = document.activeElement;

    var images = productImages(product);
    setLightboxImage(images[0] || absUrl(product.image), product.title);
    renderLightboxThumbs(product);

    if (lightboxVendorEl) lightboxVendorEl.textContent = product.vendor || 'Product details';
    if (lightboxTitleEl) lightboxTitleEl.textContent = product.title || '';
    if (lightboxPriceEl) lightboxPriceEl.innerHTML = formatPrice(product);
    renderReviews(product);
    if (lightboxScrollEl) lightboxScrollEl.scrollTop = 0;

    var variants = Array.isArray(product.variants) ? product.variants.filter(function (variant) {
      return variant && variant.available;
    }) : [];
    if (lightboxVariantEl && lightboxVariantWrap) {
      if (variants.length > 1) {
        lightboxVariantWrap.hidden = false;
        lightboxVariantEl.hidden = false;
        lightboxVariantEl.innerHTML = variants.map(function (variant) {
          return '<option value="' + escapeHtml(String(variant.id)) + '">' + escapeHtml(variant.title) + ' — ' + escapeHtml(variant.price) + '</option>';
        }).join('');
        lightboxVariantEl.value = String(product.variantId || variants[0].id);
      } else {
        lightboxVariantWrap.hidden = true;
        lightboxVariantEl.hidden = true;
        lightboxVariantEl.innerHTML = '';
      }
    }

    if (lightboxTabsEl) lightboxTabsEl.hidden = true;
    setLightboxTab('details');
    if (product.detailLoaded) {
      setLightboxDetails(product.shortDescription, detailsTableFor(product));
      setLightboxFitment(product.table);
    } else if (product.handle) {
      setLightboxDetails('<p>Loading details…</p>');
      if (lightboxFitmentEl) lightboxFitmentEl.innerHTML = '';
      fetchProductDetail(product)
        .then(function (detail) {
          if (String(state.lightboxProductId) !== String(product.id)) return;
          applyProductDetail(product, detail);
          if (detail && Array.isArray(detail.images) && detail.images.length) {
            if (!images.length) setLightboxImage(absUrl(detail.images[0]), product.title);
            renderLightboxThumbs(product);
          }
        })
        .catch(function () {
          if (String(state.lightboxProductId) !== String(product.id)) return;
          setLightboxDetails('');
          setLightboxFitment('');
        });
    } else {
      setLightboxDetails('');
      setLightboxFitment('');
    }

    if (lightboxAtcEl) {
      var variantId = product.variantId || (variants[0] && variants[0].id) || '';
      lightboxAtcEl.setAttribute('data-sr-atc', String(variantId));
      lightboxAtcEl.disabled = !variantId;
      lightboxAtcEl.textContent = 'Add to cart';
      lightboxAtcEl.classList.remove('is-added');
    }

    lightboxEl.hidden = false;
    lightboxEl.classList.add('is-open');
    var closeBtn = lightboxEl.querySelector('.fh-sr-lightbox__close');
    if (closeBtn) closeBtn.focus();
  }

  function currentLightboxVariantId() {
    if (lightboxVariantEl && !lightboxVariantEl.hidden && lightboxVariantEl.value) {
      return lightboxVariantEl.value;
    }
    return lightboxAtcEl ? lightboxAtcEl.getAttribute('data-sr-atc') : '';
  }

  function openCartDrawer() {
    closeLightbox();
    try {
      document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
    } catch (err) {
      /* theme refresh is optional */
    }
    var icon = document.querySelector('[data-js-cart-icon]');
    if (icon) {
      icon.click();
      return true;
    }
    try {
      document.dispatchEvent(new CustomEvent('cart:updated'));
      document.dispatchEvent(new CustomEvent('quick-cart:open'));
      return true;
    } catch (err) {
      return false;
    }
  }

  function refreshCartCount() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('cart');
        return res.json();
      })
      .then(function (cart) {
        var count = cart && cart.item_count ? Number(cart.item_count) : 0;
        if (!cartCountEl) return;
        cartCountEl.textContent = String(count);
        cartCountEl.hidden = count < 1;
      })
      .catch(function () {
        /* badge is optional */
      });
  }

  function addToCart(variantId, btn) {
    if (!variantId || !btn || btn.disabled) return;
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }]
      })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart add failed');
        return res.json();
      })
      .then(function () {
        btn.textContent = 'Added';
        btn.classList.add('is-added');
        openCartDrawer();
        refreshCartCount();
        window.setTimeout(refreshCartCount, 400);
        window.setTimeout(function () {
          btn.textContent = original || 'Add to cart';
          btn.classList.remove('is-added');
          btn.disabled = false;
        }, 1600);
      })
      .catch(function () {
        btn.textContent = 'Try again';
        btn.disabled = false;
        window.setTimeout(function () {
          btn.textContent = original || 'Add to cart';
        }, 1600);
      });
  }

  function dedupeProducts() {
    var seen = {};
    products = products.filter(function (product) {
      var id = String(product.id);
      if (seen[id]) return false;
      seen[id] = true;
      return true;
    });
  }

  function setLoadMessage(message) {
    if (!loadEl) return;
    if (!message) {
      loadEl.hidden = true;
      loadEl.textContent = '';
      return;
    }
    loadEl.hidden = false;
    loadEl.textContent = message;
  }

  function setContinueEnabled(enabled) {
    if (continueEl) {
      continueEl.disabled = !enabled;
      continueEl.setAttribute('aria-disabled', enabled ? 'false' : 'true');
      continueEl.setAttribute('aria-busy', enabled ? 'false' : 'true');
    }
    if (searchAllEl) {
      searchAllEl.disabled = !enabled;
      searchAllEl.setAttribute('aria-disabled', enabled ? 'false' : 'true');
    }
  }

  function loadCatalog() {
    var pageSize = config.pageSize || 250;
    var handle = config.collectionHandle || 'data-motorstate-products';
    var knownCount = Number(config.productsCount) || 0;
    var startedAt = (window.performance && performance.now) ? performance.now() : Date.now();
    var pagesRequested = 0;
    var pagesLoaded = 0;
    var pagesFailed = 0;

    setContinueEnabled(false);
    setLoadMessage('Loading products… 0%');

    function nowMs() {
      return (window.performance && performance.now) ? performance.now() : Date.now();
    }

    function ingest(batch, page) {
      if (!batch.length) return;
      var base = ((page || 1) - 1) * pageSize;
      var i;
      for (i = 0; i < batch.length; i++) {
        if (batch[i]) batch[i]._catalogIndex = base + i;
      }
      products = products.concat(batch);
      dedupeProducts();
      if (state.screen === 'categories') renderCategories();
      if (state.screen === 'products') renderProducts();
    }

    function progressMessage() {
      var total = pagesRequested || (knownCount > 0 ? Math.max(1, Math.ceil(knownCount / pageSize)) : 0);
      var pct = total ? Math.min(100, Math.round((pagesLoaded / total) * 100)) : 0;
      return 'Loading products… ' + pct + '%';
    }

    function fetchPage(page) {
      pagesRequested += 1;
      var url = '/collections/' + encodeURIComponent(handle) + '?view=showroom-json&page=' + page;
      return fetch(url, { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('Showroom catalog request failed');
          return res.text();
        })
        .then(function (text) {
          var batch = [];
          try {
            batch = JSON.parse(text);
          } catch (err) {
            throw new Error('Showroom catalog JSON invalid');
          }
          if (!Array.isArray(batch)) batch = [];
          pagesLoaded += 1;
          ingest(batch, page);
          setLoadMessage(progressMessage());
          return { page: page, batch: batch, failed: false };
        })
        .catch(function () {
          pagesFailed += 1;
          return { page: page, batch: [], failed: true };
        });
    }

    function fetchRange(fromPage, toPage) {
      var jobs = [];
      var p;
      for (p = fromPage; p <= toPage; p += 1) {
        jobs.push(fetchPage(p));
      }
      return Promise.all(jobs);
    }

    function finish() {
      products.sort(function (a, b) {
        return catalogIndex(a) - catalogIndex(b);
      });
      catalogReady = products.length > 0;
      catalogError = products.length === 0;
      setContinueEnabled(catalogReady);
      var ms = Math.round(nowMs() - startedAt);
      if (typeof console !== 'undefined' && console.info) {
        console.info(
          '[showroom] catalog loaded',
          products.length + ' products in ' + ms + 'ms',
          '(' + pagesLoaded + '/' + pagesRequested + ' pages' +
            (pagesFailed ? ', ' + pagesFailed + ' failed' : '') + ')',
          handle,
          config.collectionSource || 'fallback'
        );
      }
      if (catalogReady) {
        setLoadMessage('');
      } else {
        setLoadMessage('Unable to load inventory. Refresh and try again.');
      }
      if (state.screen === 'categories') renderCategories();
      if (state.screen === 'products') renderProducts();
    }

    var firstCount = knownCount > 0 ? Math.max(1, Math.ceil(knownCount / pageSize)) : 12;

    function loadFrom(startPage, count) {
      return fetchRange(startPage, startPage + count - 1).then(function (results) {
        var last = results[results.length - 1];
        var lastFull = last && !last.failed && last.batch.length >= pageSize;
        var anyOk = results.some(function (result) { return !result.failed; });
        if (lastFull) return loadFrom(startPage + count, 2);
        if (!anyOk && startPage === 1) throw new Error('Showroom catalog request failed');
      });
    }

    return loadFrom(1, firstCount)
      .then(finish)
      .catch(function () {
        catalogReady = products.length > 0;
        catalogError = products.length === 0;
        setContinueEnabled(catalogReady);
        setLoadMessage(catalogReady ? '' : 'Unable to load inventory. Refresh and try again.');
      });
  }

  function resetBrowseState() {
    state.category = null;
    state.mode = 'category';
    state.query = '';
    state.vendor = '';
    state.subType = '';
    state.queryVehicle = null;
    resetGridPage();
    if (searchEl) searchEl.value = '';
    setSearchIdle(false);
  }

  function goToYmm() {
    state.vehicle = null;
    state.allProducts = false;
    state.engine = '';
    resetBrowseState();
    searchPool = [];
    searchPoolKey = '';
    searchIdleKey = '';
    setSearchIdle(false);
    setScreen('ymm');
    setNotice('', false);
  }

  function goToCategories() {
    if (!catalogReady) {
      setNotice(catalogError ? 'Unable to load inventory. Refresh and try again.' : 'Loading products…', catalogError);
      return;
    }
    resetBrowseState();
    renderCategories();
    setScreen('categories');
    setNotice('', false);
  }

  function goToProducts(category) {
    state.mode = 'category';
    state.category = category;
    state.query = '';
    state.vendor = '';
    state.subType = '';
    resetGridPage();
    if (searchEl) searchEl.value = '';
    renderProducts();
    setScreen('products');
  }

  function goToSearch() {
    state.mode = 'search';
    state.category = null;
    state.query = '';
    state.vendor = '';
    state.subType = '';
    resetGridPage();
    if (searchEl) searchEl.value = '';
    ensureSearchPool();
    renderProducts();
    setScreen('products');
    window.setTimeout(function () {
      if (searchEl) searchEl.focus();
    }, 40);
  }

  function goToSearchAll() {
    if (!catalogReady) {
      setNotice(catalogError ? 'Unable to load inventory. Refresh and try again.' : 'Loading products…', catalogError);
      return;
    }
    state.vehicle = null;
    state.allProducts = true;
    state.engine = '';
    resetBrowseState();
    searchPool = [];
    searchPoolKey = '';
    searchIdleKey = '';
    goToSearch();
    setNotice('', false);
  }

  function applySearchQuery(value) {
    state.query = String(value || '');
    resetGridPage();
    if (searchEl && searchEl.value !== state.query) searchEl.value = state.query;
    if (searchRaf) window.cancelAnimationFrame(searchRaf);
    searchRaf = window.requestAnimationFrame(function () {
      searchRaf = 0;
      renderProducts();
    });
  }

  buildYmmIndex(ymmRowsAll);
  fillYears();
  restoreLastVehicle();
  refreshCartCount();
  loadCatalog();

  if (yearEl) {
    yearEl.addEventListener('change', function () {
      fillMakes();
      setNotice('', false);
    });
  }
  if (makeEl) {
    makeEl.addEventListener('change', function () {
      fillModels();
      setNotice('', false);
    });
  }
  if (modelEl) {
    modelEl.addEventListener('change', function () {
      fillEngines();
      setNotice('', false);
    });
  }
  if (engineEl) {
    engineEl.addEventListener('change', function () {
      setNotice('', false);
    });
  }

  if (formEl) {
    formEl.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!catalogReady) {
        setNotice(catalogError ? 'Unable to load inventory. Refresh and try again.' : 'Loading products…', catalogError);
        return;
      }
      var vehicle = getSelectedVehicle();
      if (!vehicle) {
        setNotice('Please complete Year, Make, and Model.', true);
        return;
      }
      writeLastVehicle(vehicle);
      state.vehicle = vehicle;
      state.allProducts = false;
      state.engine = '';
      resetBrowseState();
      goToCategories();
    });
  }

  if (searchAllEl) {
    searchAllEl.addEventListener('click', function () {
      goToSearchAll();
    });
  }

  if (backEl) {
    backEl.addEventListener('click', function () {
      closeLightbox();
      if (state.screen === 'products') {
        if (state.allProducts || !state.vehicle) {
          goToYmm();
          return;
        }
        goToCategories();
        return;
      }
      goToYmm();
    });
  }

  if (cartEl) {
    cartEl.addEventListener('click', function (event) {
      if (openCartDrawer()) event.preventDefault();
    });
  }

  if (catsEl) {
    catsEl.addEventListener('click', function (event) {
      if (event.target.closest('[data-sr-search-tile]')) {
        goToSearch();
        return;
      }
      var button = event.target.closest('[data-sr-category]');
      if (!button) return;
      goToProducts(button.getAttribute('data-sr-category'));
    });
  }

  if (searchFormEl) {
    searchFormEl.addEventListener('submit', function (event) {
      event.preventDefault();
      if (searchEl) applySearchQuery(searchEl.value);
    });
  }

  if (searchEl) {
    searchEl.addEventListener('input', function () {
      applySearchQuery(searchEl.value);
    });
  }

  if (vendorEl) {
    vendorEl.addEventListener('change', function () {
      state.vendor = vendorEl.value || '';
      resetGridPage();
      renderProducts();
    });
  }

  if (typesEl) {
    typesEl.addEventListener('click', function (event) {
      var button = event.target.closest('[data-sr-type]');
      if (!button) return;
      state.subType = button.getAttribute('data-sr-type') || '';
      resetGridPage();
      renderProducts();
    });
  }

  if (enginesEl) {
    enginesEl.addEventListener('click', function (event) {
      var button = event.target.closest('[data-sr-engine-size]');
      if (!button) return;
      state.engine = button.getAttribute('data-sr-engine-size') || '';
      resetGridPage();
      renderProducts();
    });
  }

  if (typeSelectEl) {
    typeSelectEl.addEventListener('change', function () {
      state.subType = typeSelectEl.value || '';
      resetGridPage();
      renderProducts();
    });
  }

  if (engineSelectEl) {
    engineSelectEl.addEventListener('change', function () {
      state.engine = engineSelectEl.value || '';
      resetGridPage();
      renderProducts();
    });
  }

  if (loadMoreEl) {
    loadMoreEl.addEventListener('click', function () {
      state.visibleCount = (state.visibleCount || GRID_PAGE_SIZE) + GRID_LOAD_MORE;
      renderProducts({ append: true });
    });
  }

  if (gridEl) {
    gridEl.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-sr-details]');
      if (!trigger) return;
      event.preventDefault();
      openLightbox(trigger.getAttribute('data-sr-details'));
    });
  }

  if (lightboxTabsEl) {
    lightboxTabsEl.addEventListener('click', function (event) {
      var tab = event.target.closest('[data-sr-lightbox-tab]');
      if (!tab) return;
      setLightboxTab(tab.getAttribute('data-sr-lightbox-tab'));
    });
  }

  if (lightboxEl) {
    lightboxEl.addEventListener('click', function (event) {
      if (event.target.closest('[data-sr-lightbox-close]')) {
        closeLightbox();
        return;
      }
      var thumb = event.target.closest('[data-sr-thumb]');
      if (thumb) {
        setLightboxImage(thumb.getAttribute('data-sr-thumb'), lightboxTitleEl ? lightboxTitleEl.textContent : '');
        lightboxEl.querySelectorAll('[data-sr-thumb]').forEach(function (btn) {
          btn.classList.toggle('is-active', btn === thumb);
        });
      }
    });
  }

  if (lightboxVariantEl) {
    lightboxVariantEl.addEventListener('change', function () {
      if (lightboxAtcEl) lightboxAtcEl.setAttribute('data-sr-atc', lightboxVariantEl.value);
      var product = findProductById(state.lightboxProductId);
      if (!product) return;
      var variant = (product.variants || []).filter(function (item) {
        return String(item.id) === String(lightboxVariantEl.value);
      })[0];
      if (lightboxPriceEl) lightboxPriceEl.innerHTML = formatPrice(product, variant);
      if (variant && variant.image) setLightboxImage(absUrl(variant.image), product.title);
    });
  }

  if (lightboxAtcEl) {
    lightboxAtcEl.addEventListener('click', function () {
      addToCart(currentLightboxVariantId(), lightboxAtcEl);
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeLightbox();
  });

  if (window.matchMedia) {
    var phoneMq = window.matchMedia('(max-width: 820px)');
    var onPhoneMq = function () {
      if (state.screen === 'products') renderProducts();
    };
    if (phoneMq.addEventListener) phoneMq.addEventListener('change', onPhoneMq);
    else if (phoneMq.addListener) phoneMq.addListener(onPhoneMq);
  }
})();
